import {
    FETCH_ANALYSES,
    FETCH_ANALYSIS_COMPLETE_USER_STATS,
    FETCH_CURRENT_ANALYSIS_STATS,
} from '../actions/AnalysisActions';

// INITIALIZE STATE
const initialState = {
    analysis: null,
    analyses: null,
    analysisCompleteUserStats: null,
    analysisStats: null,
    fetching: false,
    fetched: false,
    failed: false,
    paging: {
        total: 0,
        pageNumber: 1,
        pageSize: 5,
        pages: 1,
    },
};

// REDUCER
export const AnalysesReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ANALYSES}_PENDING`:
            return {
                ...state,
                analyses: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_ANALYSES}_FULFILLED`:
            return {
                ...state,
                analyses: action.payload.data,
                paging: action.payload.paging,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_ANALYSES}_REJECTED`:
            return {
                ...state,
                analyses: null,
                fetching: false,
                fetched: false,
                failed: true,
            };

        case `${FETCH_ANALYSIS_COMPLETE_USER_STATS}_PENDING`:
            return {
                ...state,
                analysisCompleteUserStats: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_ANALYSIS_COMPLETE_USER_STATS}_FULFILLED`:
            return {
                ...state,
                analysisCompleteUserStats: action.payload.data,
                paging: action.payload.paging,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_ANALYSIS_COMPLETE_USER_STATS}_REJECTED`:
            return {
                ...state,
                analysisCompleteUserStats: null,
                fetching: false,
                fetched: false,
                failed: true,
            };

        case `${FETCH_CURRENT_ANALYSIS_STATS}_PENDING`:
            return {
                ...state,
                analysisStats: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_CURRENT_ANALYSIS_STATS}_FULFILLED`:
            return {
                ...state,
                analysisStats: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_CURRENT_ANALYSIS_STATS}_REJECTED`:
            return {
                ...state,
                analysisStats: null,
                fetching: false,
                fetched: false,
                failed: true,
            };

        default:
            return state;
    }
};
